<div class="main-container" [class.mobile]="isHandset$ | async">
  <div class="container-bienvenue-alert">
    <div class="container-bienvenue">
      <div class="main-content">
        <div class="main-content-header">
          <div>
            <div><span class="title">Bonjour</span></div>
            <div>
              <span class="subtitle">Bienvenue dans votre espace de facturation PPA</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-error-log">
      <app-error-log></app-error-log>
    </div>
  </div>
  <div class="import-content">
    <app-summary-invoices
      [error]="error"
      [invoicesSummary]="invoicesSummary"
      [loading]="loadingSummary"
    ></app-summary-invoices>
    <app-treshold-notification
      [loading]="loadingSummary"
      [error]="error"
      [invoicesSummary]="invoicesSummary"
    ></app-treshold-notification>
  </div>
</div>
